import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "big-mode"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "big-mode__gnb" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, " 즐거운 사람들의 즐거운 비즈니스 ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode(" 사람을 위한 모바일 세상을 함께 만들어가는 사람들, "),
  /*#__PURE__*/_createElementVNode("b", null, "더조인"),
  /*#__PURE__*/_createTextVNode("입니다. ")
], -1)
const _hoisted_5 = {
  key: 1,
  class: "small-mode"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Company", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "TheJOIN", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", { class: "small-mode__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow_right_top" })
], -1)
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "small-mode healthU"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "healthU" }, " Healthcare Platform ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", { class: "healthU" }, "Health&u", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", { class: "small-mode__icon healthU" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow_right_top healthU" })
], -1)
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "lottie-wrap healthU" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "big-mode__gnb healthU" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h1", { class: "healthU" }, [
  /*#__PURE__*/_createTextVNode(" 건강한 경험을 지원하는"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 헬스케어 플랫폼 ")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", { class: "healthU" }, [
  /*#__PURE__*/_createTextVNode(" 당신의 고객에게 보다 효과적인 디지털 헬스케어 서비스를"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 제공할 수 있도록 "),
  /*#__PURE__*/_createElementVNode("b", { class: "healthU" }, "최적화된 도구"),
  /*#__PURE__*/_createTextVNode("를 지원합니다. ")
], -1)
const _hoisted_19 = {
  key: 0,
  class: "small-mode virtual"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", { class: "virtual" }, " Mobile Security ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h2", { class: "virtual" }, "J-VMP", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("button", { class: "small-mode__icon virtual" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow_right_top virtual" })
], -1)
const _hoisted_23 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "lottie-wrap virtual" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "big-mode__gnb virtual" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h1", { class: "virtual" }, [
  /*#__PURE__*/_createTextVNode(" 기업의 안전한 업무를 위한"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 모바일 가상화 솔루션 ")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h2", { class: "virtual" }, [
  /*#__PURE__*/_createTextVNode(" 안전하고 편리한 모바일 서비스 운영 환경을 위한"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", { class: "virtual" }, "최적의 보안 솔루션 J-VMP"),
  /*#__PURE__*/_createTextVNode("를 경험해보세요. ")
], -1)
const _hoisted_28 = {
  key: 1,
  class: "home-tablet fullpage"
}
const _hoisted_29 = { class: "big-mode" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "big-mode__gnb" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode(" 즐거운 사람들의 "),
  /*#__PURE__*/_createElementVNode("br", { class: "mbr" }),
  /*#__PURE__*/_createTextVNode("즐거운 비즈니스 ")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode(" 사람을 위한 모바일 세상을 함께"),
  /*#__PURE__*/_createElementVNode("br", { class: "mbr" }),
  /*#__PURE__*/_createTextVNode(" 만들어가는 사람들, "),
  /*#__PURE__*/_createElementVNode("b", null, "더조인"),
  /*#__PURE__*/_createTextVNode("입니다. ")
], -1)
const _hoisted_33 = {
  key: 2,
  class: "home-tablet fullpage"
}
const _hoisted_34 = { class: "lottie-wrap" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "lottie-wrap__gnb" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode(" 건강한 경험을 지원하는 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("헬스케어 플랫폼 ")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode(" 당신의 고객에게 보다 효과적인 디지털 헬스케어 서비스를"),
  /*#__PURE__*/_createElementVNode("br", { class: "tbr" }),
  /*#__PURE__*/_createTextVNode(" 제공할 수 있도록 "),
  /*#__PURE__*/_createElementVNode("b", null, "최적화된 도구"),
  /*#__PURE__*/_createTextVNode("를 지원합니다. ")
], -1)
const _hoisted_38 = {
  key: 3,
  class: "home-tablet fullpage"
}
const _hoisted_39 = { class: "lottie-wrap jvmp" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "lottie-wrap__gnb" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode(" 기업의 안전한 업무를 위한"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 모바일 가상화 솔루션 ")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode(" 안전하고 편리한 모바일 서비스 운영 환경을 위한"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "최적의 보안 솔루션 J-VMP"),
  /*#__PURE__*/_createTextVNode("를 경험해보세요. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomBtn = _resolveComponent("CustomBtn")!
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_Layout = _resolveComponent("Layout")!

  return (_openBlock(), _createBlock(_component_Layout, {
    isDark: true,
    hasFooter: false,
    topPadding: true
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        ($setup.isPc)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "home-web fullpage",
              onMouseover: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.hoverFn && $setup.hoverFn(...args)))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["home-web__about", $setup.aboutHover ? null : 'small'])
              }, [
                ($setup.aboutHover)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _hoisted_2,
                      _hoisted_3,
                      _hoisted_4,
                      _createVNode(_component_CustomBtn, {
                        isDark: true,
                        text: '더 알아보기',
                        onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/about')))
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_9))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["home-web__hover-area first healthU", $setup.healthHover ? 'hover' : null])
              }, [
                (!$setup.healthHover)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_14))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["big-mode healthU", 
								$setup.healthFadeUp ? 'active' : false
							])
                  }, [
                    _hoisted_16,
                    _hoisted_17,
                    _hoisted_18,
                    _createVNode(_component_CustomBtn, {
                      isDark: false,
                      text: '더 알아보기',
                      onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/health'))),
                      classNm: 'healthU'
                    })
                  ], 2),
                  ($setup.healthLottie)
                    ? _withDirectives((_openBlock(), _createBlock(_component_Vue3Lottie, {
                        key: 0,
                        loop: false,
                        animationData: $setup.lottie1,
                        class: "lottie-wrap__lottie"
                      }, null, 8, ["animationData"])), [
                        [_vShow, $setup.healthHover]
                      ])
                    : _createCommentVNode("", true)
                ], 512), [
                  [_vShow, $setup.healthHover]
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["home-web__hover-area virtual", $setup.jvmphHover ? 'hover' : null])
              }, [
                (!$setup.jvmphHover)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_23))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["big-mode virtual", 
								$setup.jvmpFadeUp ? 'active' : false
							])
                  }, [
                    _hoisted_25,
                    _hoisted_26,
                    _hoisted_27,
                    _createVNode(_component_CustomBtn, {
                      isDark: false,
                      text: '더 알아보기',
                      onOnClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/jvmp'))),
                      classNm: 'virtual'
                    })
                  ], 2),
                  ($setup.jvmpFadeUp)
                    ? _withDirectives((_openBlock(), _createBlock(_component_Vue3Lottie, {
                        key: 0,
                        loop: false,
                        animationData: $setup.lottie2,
                        class: "lottie-wrap__lottie virtual"
                      }, null, 8, ["animationData"])), [
                        [_vShow, $setup.jvmphHover]
                      ])
                    : _createCommentVNode("", true)
                ], 512), [
                  [_vShow, $setup.jvmphHover]
                ])
              ], 2)
            ], 32))
          : _createCommentVNode("", true),
        (!$setup.isPc)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _hoisted_31,
                _hoisted_32,
                _createVNode(_component_CustomBtn, {
                  isDark: true,
                  text: '더 알아보기',
                  onOnClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/about')))
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (!$setup.isPc)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _hoisted_36,
                _hoisted_37,
                _createVNode(_component_CustomBtn, {
                  isDark: true,
                  text: '더 알아보기',
                  onOnClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/health')))
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (!$setup.isPc)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _hoisted_41,
                _hoisted_42,
                _createVNode(_component_CustomBtn, {
                  isDark: true,
                  text: '더 알아보기',
                  onOnClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/jvmp')))
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Footer, {
          isDark: true,
          class: "fullpage"
        })
      ])
    ]),
    _: 3
  }))
}